// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__35pe9","header":"ReportDetails_header__3cT1Y","title":"ReportDetails_title__2G0FA","left":"ReportDetails_left__2zd9v"};